import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corporate-page',
  templateUrl: './corporate-page.component.html',
  styleUrls: ['./corporate-page.component.css']
})
export class CorporatePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
